module.exports = __webpack_public_path__ + "static/img/logo-2.1303aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo-2.png
// module id = NYA8
// module chunks = 12